"use client";
import Button from "@/components/Cards/Button";
import { TextInput } from "@/components/Inputs/TextInput";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import { ButtonDark, MdButton } from "@/stories/Button.stories";
import { useForm, zodResolver } from "@mantine/form";
import { useState } from "react";
import { z } from "zod";
import ErrorModal from "../ErrorModal";

export default function KontaktForm({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);
    const schema = z.object({
        request: z.string(),
        anrede: z.string(),
        name: z.string(),
        surname: z.string(),
        email: z
            .string()
            .email()
            .refine((email) => email.length > 0, {
                message: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            }),
        phone: z.string(),
    });
    const form = useForm({
        initialValues: {
            request: "",
            anrede: "",
            name: "",
            surname: "",
            email: "",
            phone: "",
        },
        validate: zodResolver(schema),
    });

    return (
        <>
            <div>
                <div className="text-black  px-5 py-5 text-xl3 lg:text-5xl font-bold leading-8.5 lg:leading-14">
                    Send us a message
                </div>

                <form
                    className="space-y-3 px-5"
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            anrede: values.anrede,
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                            phone: values.phone,
                            request: values.request,
                        };
                        sendEmail("Kontakt", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch((e) => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                    })}
                >
                    <div>
                        <TextInput
                            type="textarea"
                            id="request"
                            name="request"
                            placeholder={"enter here"}
                            label={"Your message"}
                            backgroundColor="bg-yellow"
                            height="min-h-36"
                            width={"lg:w-[610px] w-full"}
                            {...form.getInputProps("request")}
                        />
                    </div>

                    <TextInput
                        id="name"
                        name="name"
                        type="text"
                        placeholder={"enter here"}
                        label={"First name"}
                        backgroundColor="bg-yellow"
                        width={"lg:w-[610px] w-full"}
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        id="surname"
                        name="surname"
                        type="text"
                        placeholder={"enter here"}
                        label={"Surname"}
                        backgroundColor="bg-yellow"
                        width={"lg:w-[610px] w-full"}
                        {...form.getInputProps("surname")}
                    />
                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        placeholder={"enter here"}
                        label={"Email"}
                        backgroundColor="bg-yellow"
                        width={"lg:w-[610px] w-full"}
                        {...form.getInputProps("email")}
                    />

                    <Button
                        backgroundColor={MdButton.args?.backgroundColor}
                        size={""}
                        hasIcon={MdButton.args?.hasIcon}
                        text={"SEND MESSAGE"}
                        paddings={"px-3 py-4"}
                        rounded={MdButton.args?.rounded}
                        textColor={MdButton.args?.textColor}
                        textSize={MdButton.args?.textSize}
                    />
                </form>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            paddings=""
                            title={"Thank you for your message!"}
                            paragraphs={[
                                "I have received your message. I will get back to you as soon as possible. In general, messages are answered within a day, but at the latest within 48 hours.",
                                "Best regards",
                                "Rico Brunner",
                            ]}
                        />
                        <div className="flex py-5 justify-end">
                            <Button
                                size={ButtonDark.args?.size}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={ButtonDark.args?.hasIcon}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                as="a"
                                href={"/"}
                            />
                        </div>
                    </>
                </InfoModal>
            </div>
        </>
    );
}
